/// <reference path="../HTML/Menu/AppMenu.ts" />
namespace HA.Core.Entity {
    import AppMenu = HA.Core.HTML.Menu.AppMenu;

    export class AppMenuManager extends Entity {
        /**
         *
         * @param menuData
         */
        public show(menuData: Array<Map<any, any>>) {
            const c: AppMenu = this.getAppContainer();
            c.addItems(menuData);
            c.show();
        }

        /**
         *
         * @returns {AppMenu}
         */
        protected getAppContainer() {
            return this.get("appContainer");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("appContainer", new AppMenu(data));
           // this.initSubscribers();
        }

    }
}
